module.exports = __webpack_public_path__ + "static/media/PSIO Vector 02 animated.d86bae7d.svg";